import React from 'react';
import {View, StyleSheet } from '@react-pdf/renderer';
import TableHeader from './TableHeader'
import TableRow from './TableRow'

const styles = StyleSheet.create({
    tableContainer: {
        flexDirection: 'row',
        flexWrap: 'wrap',
        borderWidth: 1,
        borderBottom: 'none',
        borderColor: '#000000',
    },
});

  const ItemsTable = ({data}) => (
    <View style={styles.tableContainer}>
        <TableHeader />
        <TableRow items={data} />
    </View>
  );
  
  export default ItemsTable